import { Card, Flex, Image, styled } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';

const styles = {
  Card: styled(Card, {
    padding: '0',
    overflow: 'hidden',
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    '@tablet': {
      maxWidth: '260px',
      maxHeight: '296px',
    },
  }),

  ImageWrapper: styled(Flex, {
    '@tablet': {
      maxHeight: 'calc($23 + $12)',
    },
  }),

  Image: styled(Image, {
    height: '100%',
    objectFit: 'cover',
    overflow: 'hidden',
    width: '100%',
    '@tablet': {
      height: 'initial',
      objectFit: 'cover',
      maxHeight: 'calc($23 + $12)',
    },
  }),

  Content: styled(Flex, {
    flex: '1 1 auto',
    overflow: 'hidden',
    whiteSpace: 'pre-line',
    padding: '$4 $4',
    boxSizing: 'border-box',
  }),

  Title: styled(ResponsiveFloraTypography, {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineClamp: 1,
    '-webkit-line-clamp': 1,
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    wordWrap: 'break-word',
  }),

  Description: styled(ResponsiveFloraTypography, {
    height: '$12',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineClamp: 2,
    '-webkit-line-clamp': 2,
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    wordWrap: 'break-word',
  }),
};

export default styles;
